import { PropsWithChildren } from 'react';

export function SettingsFields({ children }: PropsWithChildren) {
  return (
    <div className="grid grid-cols-2 gap-x-6 gap-y-4 sm:grid-cols-2 md:col-span-3">
      {children}
    </div>
  );
}
